import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi } from "./api";

const AuthContext = createContext({ user: null, login: null, logout: null });
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=not authed, object=authed

  useEffect(() => {
    adminApi.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await adminApi.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  }, []);

  const refreshUser = useCallback(async () => {
    try { const r = await adminApi.get("/auth/me"); setUser(r.data); } catch (e) { setUser(false); }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
